/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseErrorBadRequestAllOfError
 */
export interface ResponseErrorBadRequestAllOfError {
    /**
     * 
     * @type {string}
     * @memberof ResponseErrorBadRequestAllOfError
     */
    code: ResponseErrorBadRequestAllOfErrorCodeEnum;
}


/**
 * @export
 */
export const ResponseErrorBadRequestAllOfErrorCodeEnum = {
    BadRequest: 'bad_request'
} as const;
export type ResponseErrorBadRequestAllOfErrorCodeEnum = typeof ResponseErrorBadRequestAllOfErrorCodeEnum[keyof typeof ResponseErrorBadRequestAllOfErrorCodeEnum];


/**
 * Check if a given object implements the ResponseErrorBadRequestAllOfError interface.
 */
export function instanceOfResponseErrorBadRequestAllOfError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ResponseErrorBadRequestAllOfErrorFromJSON(json: any): ResponseErrorBadRequestAllOfError {
    return ResponseErrorBadRequestAllOfErrorFromJSONTyped(json, false);
}

export function ResponseErrorBadRequestAllOfErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorBadRequestAllOfError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function ResponseErrorBadRequestAllOfErrorToJSON(value?: ResponseErrorBadRequestAllOfError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

